/**
 * Traxccel wordmark. txl_lite_big.webp (772x290) has transparent padding around the artwork
 * (artwork box is roughly x 86-760, y 66-174), so it is cropped here: the box is exactly the
 * artwork, which keeps it vertically centred with the rest of the row at any size.
 */
export default function Logo({ className = "" }: { className?: string }) {
  const basename = process.env.PUBLIC_URL || "";
  return (
    <span className={`rl-logo ${className}`}>
      <img src={`${basename}/images/txl_lite_big.webp`} alt="Traxccel" />
    </span>
  );
}
